// import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DateRange } from "@mui/icons-material";
import Checkbox from '@mui/material/Checkbox';
import { Button } from "react-bootstrap";
import { Switch } from '@mui/material';

import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { createLanguage, updateLanguage, getAllLanguagesList } from "../actions/manageLanguagesActions";

const LanguageConfig = () => {
  
 const { allLanguagesList } = useSelector(
      (state) => state.manageLanguagesReducer,
      shallowEqual
    );
  const [activeLanguages, setActiveLanguages] = useState([]); // Active ones only
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllLanguagesList())
  }, []);
   useEffect(() => {
    let currentLanguageList = allLanguagesList && allLanguagesList.languageConfigDtos && allLanguagesList.languageConfigDtos.length > 0 ? allLanguagesList.languageConfigDtos.filter(dt=>dt.isActive).map(lang=>lang.language) : []
    setActiveLanguages(currentLanguageList)
  }, [allLanguagesList]);

  const toggleLanguage = (language) => {
    if (activeLanguages.includes(language)) {
      setActiveLanguages(activeLanguages.filter(l => l !== language));
    } else {
      setActiveLanguages([...activeLanguages, language]);
    }
  };

  const handleSubmit = () => {
    const languageConfigDtos = allLanguagesList && allLanguagesList.languageConfigDtos && allLanguagesList.languageConfigDtos.length > 0 && allLanguagesList.languageConfigDtos.map(langData => ({
      ...langData,
      isActive: activeLanguages.includes(langData.language)
    }));
    const hasActive = languageConfigDtos.some(lang => lang.isActive);

    if (!hasActive) {
      toastr.warning("At least one language must be active.");
    } else {
      const payload = {
        keyType: 'language',
        languageConfigDtos
      };
      
      dispatch(createLanguage(payload))
    }
    
  };

  // const handleSubmit = async () => {
  //   const payload = generatePayload();
  //   dispatch(createLanguage(payload))
  // };


  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h2>Language Settings</h2>

      {/* {languages.length === 0 && <p>No languages found.</p>} */}
      <div className='row mt-2' style={{ marginBottom: '10px' }}>
        {allLanguagesList && allLanguagesList.languageConfigDtos ? allLanguagesList.languageConfigDtos.map(dt=> {
          return <div className='col-2' key={dt.language} >
                <Switch checked={activeLanguages.includes(dt.language)} onChange={(e)=>{toggleLanguage(dt.language)}}/>
                {` ${dt.language}`}
              </div>
          })
          : <p>No languages found.</p>
        }
      </div>
      <div className='row'>
        <div className='col-2'>
          <Button style={{ float:'left', marginTop:"2rem" }} onClick={handleSubmit} size="sm" type="submit">
            Save Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LanguageConfig;